import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
const initialState = {
  isAuth: !!localStorage.getItem("token"),
  user: {
    id: null,
    role: null,
  },
};

export const appSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuth = true;
      localStorage.setItem("token", action.payload.token);
      state.user = jwtDecode(action.payload.token);
    },
    logout: () => {
      localStorage.removeItem("token");
    },
    storeMe: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { login, logout, storeMe } = appSlice.actions;

export default appSlice.reducer;
